import { UploadLookContextType } from '../../context/types/UploadLookContextType';
import { UploadLookContext } from '../../context/UploadLookContext';
import { useContext } from 'react';

import { FiltersContext } from '../../context/FiltersContext';
import { FiltersContextType } from '../../context/types/FiltersContextType';
import styled from 'styled-components';
import Header from '../Header';
import ModalScreen from '../Modal';
import UploadReferencedLook from '../Modal/UploadReferencedLook';
import Filters from '../Modal/Filters';
import Looks from '../Looks';
import {
  MIN_TABLET_BODY_WIDTH,
  MIN_PC_BODY_WIDTH,
  MIN_PC_S_BODY_WIDTH,
  MIN_MOBILE_BODY_WIDTH,
} from '../../constants/StylistConstants';

const Index = () => {
  const { showUploadLook } = useContext(
    UploadLookContext,
  ) as UploadLookContextType;
  const { showFilters } = useContext(FiltersContext) as FiltersContextType;

  return (
    <Container>
      <Header />
      {showUploadLook && (
        <ModalScreen label={'Upload referenced look'}>
          <UploadReferencedLook />
        </ModalScreen>
      )}
      {showFilters && (
        <ModalScreen label={'Filters'}>
          <Filters />
        </ModalScreen>
      )}
      <Looks />
    </Container>
  );
};

const Container = styled.div`
  margin: auto;
  max-width: ${MIN_PC_BODY_WIDTH}px;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    max-width: ${MIN_PC_S_BODY_WIDTH}px;
  }

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    max-width: ${MIN_TABLET_BODY_WIDTH}px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    max-width: ${MIN_MOBILE_BODY_WIDTH}px;
  }
`;

export default Index;
